<template>
  <v-toolbar-items class="navigationButtons" :class="{large: this.$vuetify.breakpoint.lgAndUp}">
    <v-btn text :to="{ name: 'home' }">
      <v-img contain :src="require('@/assets/icons/ico-home.svg')" />
    </v-btn>
    <v-divider vertical class="mx-4" />
    <v-btn text :to="{ name: 'portfolio' }">
      <v-img class="mr-2" :src="require('@/shared/assets/icons/ico-portfolio.svg')" />
      <span>
        {{ $t('mainSections.portfolio.' + getNavigationTextModifier()) }}
      </span>
    </v-btn>
    <v-icon color="#D3D2D2">
      chevron_right
    </v-icon>
    <v-btn text :to="{ name: 'journalv2' }">
      <v-img class="mr-2" :src="require('@/shared/assets/icons/ico-newspaper.svg')" />
      <span>
        {{ $t('mainSections.journal.' + getNavigationTextModifier()) }}
      </span>
    </v-btn>
    <v-icon color="#D3D2D2">
      chevron_right
    </v-icon>
    <v-btn text :to="{ name: 'reflections' }">
      <v-img class="mr-2" :src="require('@/shared/assets/icons/ico-reflection.svg')" />
      <span>
        {{ $t('mainSections.reflection.' + getNavigationTextModifier()) }}
      </span>
    </v-btn>
  </v-toolbar-items>
</template>
<script>
export default {
  name: 'NavigationButtons',
  methods: {
    getNavigationTextModifier() {
      if (this.$vuetify.breakpoint.lgAndUp) {
        return 'long';
      }
      return 'short';
    },
  },
};
</script>

<style scoped>
.navigationButtons {
  width: 600px;
}

.navigationButtons.large {
  width: 700px;
}

.navigationButtons .v-btn--active::before {
  opacity: 0;
}

.navigationButtons .v-image {
  height: 27px;
}

.navigationButtons span{
  font-size: 13px;
  font-weight: 500;
  color: #232137;
}
</style>
